<template>
  <div :id="id" style="width:100%;height: 460px;"></div>
</template>
<script>
import { Funnel, FUNNEL_CONVERSATION_FIELD } from '@antv/g2plot';

export default {
  props: {
    list: Array
  },
  data() {
    return {
      dom: {},
      id: 'container_v' + Math.random(),
      funnelPlot: {}
    };
  },
  watch: {
    list() {
      this.funnelPlot.update(this.getOptions());
    }
  },
  created() {},
  mounted() {
    this.renderChart();
  },
  methods: {
    renderChart() {
      this.funnelPlot = new Funnel(this.id, this.getOptions());
      this.funnelPlot.render();
    },
    getOptions() {
      let data = this.list;
      data = data.length === 0 ? [{ label: '', value: 0 }] : data;
      return {
        data: data,
        xField: 'label',
        yField: 'value',
        isTransposed: true,
        label: {
          formatter: datum => {
            return datum.label;
          }
        },
        conversionTag: {
          formatter: datum => {
            return (100 * (datum[FUNNEL_CONVERSATION_FIELD][1] / datum[FUNNEL_CONVERSATION_FIELD][0])).toFixed(2) + '%';
          }
        }
      };
    }
  }
};
</script>
<style lang="less" scoped></style>
